export default {
    es: {
        fm: {
            // Toolbar
            uploadFile: 'Cargar Archivo',
            createFolder: 'Crear Carpeta',
            delete: 'Borrar',
            properties: 'Propiedades',
            download: 'Descargar',
            notifications: 'Solicitudes',
            noErrors: 'Sin errores pendientes',
            reload: 'Recargar',
            hide: 'Ocultar',
            unhide: 'Mostrar',
            folderHidden: 'Carpeta oculta',
            folderShown: 'Carpeta visible',
            // Tree
            explorer: 'Explorador',
            // Path bar
            searchPlaceholder: 'Buscar archivos...',
            dropToUpload: 'Soltar para subir en',
            // Table headers
            name: 'Nombre',
            createdBy: 'Creador',
            createdAt: 'Fecha Creación',
            modifiedBy: 'Modificado Por',
            modifiedAt: 'Fecha Modificación',
            id: 'ID',
            emptyFolder: 'Carpeta vacía',
            // Delete dialog
            confirmDelete: 'Confirmar eliminación',
            confirmDeleteMessage: '¿Está seguro que desea eliminar los siguientes archivos?',
            cancel: 'Cancelar',
            eliminate: 'Eliminar',
            // Edit dialog
            editFile: 'Editar archivo',
            path: 'Ruta',
            fieldName: 'Nombre',
            fileType: 'Tipo Archivo',
            description: 'Descripción',
            fileTemplate: 'Plantilla Archivo',
            activated: 'Activado',
            processFile: 'Procesar Archivo',
            save: 'Guardar',
            // Process dialog
            file: 'Archivo',
            template: 'Plantilla',
            templateNotFound: 'Plantilla no encontrada',
            noTemplate: 'Sin plantilla seleccionada',
            back: 'Volver',
            process: 'Procesar',
            // Context menu
            deleteSelected: 'Eliminar Seleccionados',
            downloadSelected: 'Descargar Seleccionados',
            copyPath: 'Copiar Ruta',
            rename: 'Renombrar',
            // Notifications
            pathCopied: 'Ruta copiada al portapapeles',
            renamedTo: 'Renombrado a "{name}"',
            deleted: '"{name}" eliminado',
            deletedMany: '{count} archivos eliminados',
            folderCreated: 'Carpeta creada',
            downloadStarted: 'Iniciando descarga...',
            uploadSuccess: 'Archivo(s) subido(s) correctamente',
            movedSuccess: 'Movido correctamente',
            // Viewer
            view: 'Ver',
            preview: 'Vista previa',
            loadingPreview: 'Cargando vista previa...',
            previewError: 'No se pudo cargar la vista previa',
            noPreview: 'No hay vista previa disponible para este tipo de archivo',
            downloadToView: 'Descargar para ver',
            sheet: 'Hoja',
            firstRowsNote: 'Mostrando las primeras {n} filas',
            openInNewTab: 'Abrir en pestaña nueva',
        },
    },
    en: {
        fm: {
            // Toolbar
            uploadFile: 'Upload File',
            createFolder: 'Create Folder',
            delete: 'Delete',
            properties: 'Properties',
            download: 'Download',
            notifications: 'Notifications',
            noErrors: 'No pending errors',
            reload: 'Reload',
            hide: 'Hide',
            unhide: 'Unhide',
            folderHidden: 'Folder hidden',
            folderShown: 'Folder shown',
            // Tree
            explorer: 'Explorer',
            // Path bar
            searchPlaceholder: 'Search files...',
            dropToUpload: 'Drop to upload in',
            // Table headers
            name: 'Name',
            createdBy: 'Created by',
            createdAt: 'Created at',
            modifiedBy: 'Modified by',
            modifiedAt: 'Modified at',
            id: 'ID',
            emptyFolder: 'Empty folder',
            // Delete dialog
            confirmDelete: 'Confirm deletion',
            confirmDeleteMessage: 'Are you sure you want to delete the following files?',
            cancel: 'Cancel',
            eliminate: 'Delete',
            // Edit dialog
            editFile: 'Edit file',
            path: 'Path',
            fieldName: 'Name',
            fileType: 'File type',
            description: 'Description',
            fileTemplate: 'File template',
            activated: 'Activated',
            processFile: 'Process File',
            save: 'Save',
            // Process dialog
            file: 'File',
            template: 'Template',
            templateNotFound: 'Template not found',
            noTemplate: 'No template selected',
            back: 'Back',
            process: 'Process',
            // Context menu
            deleteSelected: 'Delete Selected',
            downloadSelected: 'Download Selected',
            copyPath: 'Copy Path',
            rename: 'Rename',
            // Notifications
            pathCopied: 'Path copied to clipboard',
            renamedTo: 'Renamed to "{name}"',
            deleted: '"{name}" deleted',
            deletedMany: '{count} files deleted',
            folderCreated: 'Folder created',
            downloadStarted: 'Starting download...',
            uploadSuccess: 'File(s) uploaded successfully',
            movedSuccess: 'Moved successfully',
            // Viewer
            view: 'View',
            preview: 'Preview',
            loadingPreview: 'Loading preview...',
            previewError: 'Could not load the preview',
            noPreview: 'No preview available for this file type',
            downloadToView: 'Download to view',
            sheet: 'Sheet',
            firstRowsNote: 'Showing the first {n} rows',
            openInNewTab: 'Open in new tab',
        },
    },
}
